import { Component } from "react";
import "../css/bootstrap.css";

class footerSub extends Component {

  render() {
    return (
        <p className="hashtag">
        <strong>
          <sup>*</sup>T&amp;C Apply/Disclaimer:{" "}
        </strong>
        B&amp;WSSC and CIDESCO certified courses are presently
        available at{" "}
        <a
          //  data-toggle="modal" data-target="#exampleModal"
          className="link-text"
          id="selectenters"
        >
          SELECT CENTRES ONLY
        </a>
        . For more details email:{" "}
        <a
          href="mailto:customercare@aptech.ac.in"
          className="link-text"
        >
          customercare@aptech.ac.in
        </a>
        </p>
           
    );
  }
}
export default footerSub;
